import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import heroBg from '../../assets/1.jpg'; 

// Apne local images yaha import karo
import railwaysLogo from '../../assets/rail.webp';
import indiaLogo from '../../assets/delhiGov.webp';
import metroLogo from '../../assets/awho.webp';
import sbiLogo from '../../assets/vidhan.webp';

const GovProject = () => {
  const govImages = [
    { src: railwaysLogo, name: "Indian Railways" },
    { src: indiaLogo, name: "Delhi Goverment" },
    { src: metroLogo, name: "Awho" },
    { src: sbiLogo, name: "" },
  ];

  return (
    <div className="w-full">
      {/* Hero Section */}
      <div
        className="w-full h-[400px] md:h-[300px] bg-cover bg-center flex flex-col justify-center px-6 overflow-hidden"
        style={{ backgroundImage: `url(${heroBg})` }}
      >
        <motion.div
          initial={{ y: -200, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          transition={{ duration: 1.5, ease: "easeOut" }}
        >
          <h1 className="text-white text-4xl md:text-5xl font-bold">Gov Project</h1>
          <div className="text-white mt-2 text-lg">
            <Link to="/" className="underline hover:text-gray-200">Home</Link> / Gov Project
          </div>
        </motion.div>
      </div>

      {/* Page Content */}
      <div className="max-w-7xl mx-auto py-10 px-6">
        <hr />
        <h2 className="text-2xl md:text-3xl font-bold text-gray-800 text-center mb-10">
          Our Government Projects
        </h2>

        {/* Ek hi motion.div for all cards */}
        <motion.div
          initial={{ opacity: 0, y: 100 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 2, ease: "easeOut" }}
          className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-8"
        >
          {govImages.map((img, idx) => (
            <div
              key={idx}
              className="flex flex-col items-center bg-white rounded-lg shadow-md p-4 hover:shadow-lg transition"
            >
              <img
                src={img.src}
                alt={img.name}
                className="w-32 h-32 object-contain mb-4"
              />
              <p className="font-semibold text-gray-700 text-center">{img.name}</p>
            </div>
          ))}
        </motion.div>
      </div>
    </div>
  );
};

export default GovProject;
